import { FunctionComponent, useEffect } from "react";
import { useState } from "react";
import ExtraPaymentsApi from '../../api/extraPayments';
import { CarRideLocations } from '../../types/extraPayments';
import { Dictionary } from '../../components';
import { Typography, Input, Switch, Dialog } from '../../tailwindcomponents';
import { Button } from '../../tailwindcomponents';

const Destinations: FunctionComponent = () => {
  const [destination, setDestination] = useState(Array<CarRideLocations>());
  const [newDestination, setNewDestination] = useState<string>("");
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const [reason, setReason] = useState<string>("");

  const [showActive, setShowActive] = useState<boolean>(true);
  const [carRideLocationId, setCarRideLocationId] = useState<number>(-1);
  const [valadiationText, setValidationText] = useState(false);

  useEffect(() => {
    refresh();
  }, []);

  const refresh = () => {
    ExtraPaymentsApi.GetAllCarRideLocation().then(res => {
      setDestination(res.data);
      setCarRideLocationId(-1);
      setReason("");
      setValidationText(false);
    });
  }
  const addDestination = () => {
    ExtraPaymentsApi.AddCarRideLocation(newDestination).then(res => {
      refresh();
    });
  }
  const onOpenDeleteDialog = (row: CarRideLocations) => {
    setIsDialogOpen(true);
    setCarRideLocationId(row.car_ride_location_id);
  }
  const onDeleteDestination = (status: boolean) => {
    if (status === true && carRideLocationId > -1 && reason !== "" && !valadiationText) {
      ExtraPaymentsApi.DeleteCarRideLocation(reason, carRideLocationId).then(res => {
        refresh();
        setIsDialogOpen(false);
      });
    }
    else if (status === true && reason === "") {
      setValidationText(true);
    }
    else if (status === false) {
      setIsDialogOpen(false);
    }
  }

  const onInputChange = (text: string) => {
    setReason(text);
    if (text !== "") {
      setValidationText(false);
    }
  }

  return (
    <div>
      <div className="w-full flex items-start justify-center" >
        <div className="w-1/2">
          <div className="flex flex-wrap w-full">
            <div className="w-1/3 lg:w-1/12">
              <Typography text="Current" variant="subtitle2" color="textPrimary" margin={[2, 0, 0, 0]} />
            </div>
            <div className="w-1/6 lg:w-1/12 mt-2 ml-2">
              <Switch
                checked={!showActive}
                onChange={() => setShowActive(!showActive)}
                color="secondary"
                name="checkedB"
              />
            </div>
            <div className="w-1/6 lg:w-1/12">
              <Typography text="History" variant="subtitle2" color="textPrimary" margin={[2, 0, 0, 2]} />
            </div>
          </div>
          <div className="w-5/6">
            {
              destination !== undefined && destination.filter(type => type.visible === showActive).map(row => (
                <Dictionary deleteProperty={(row: CarRideLocations) => onOpenDeleteDialog(row)} deleteButton={true} name={row.location} object={row} deleted={showActive === true ? false : true} id={row.car_ride_location_id} ></Dictionary>
              ))
            }
          </div>
        </div>
        <div className="flex flex-wrap w-5/12">
          <div className="w-full">
            <br />
            <Input
              multiline={false}
              label_text="Add Destination"
              help_text="Please type in Destination"
              type="text"
              value={newDestination}
              width={50}
              onTextChange={(value: string) => setNewDestination(value)}
            />
          </div>
          <br />
          <Button variant="contained" color="primary" className="bg-accent text-[color:var(--ds-accent-fg)] text-sm" onClick={() => addDestination()} >
            Add Destination
          </Button>
        </div>
      </div>
      <Dialog
        visible={isDialogOpen}
        max_width={"sm"}
        title={"Delete destination"}
        context={
          <div>
            <Input
              error={valadiationText}
              multiline={true}
              help_text={valadiationText ? "Reason can not be blank" : ""}
              label_text={"Please provide a reason"}
              value={reason}
              onTextChange={(text: string) => onInputChange(text)}
              type="text"
              width={100}
            />
          </div>
        }
        onClose={(status: any) => onDeleteDestination(status)}
        strict={false}
        show_options={true}
      />
    </div>
  )
}

export default Destinations;